import TextLink from '../../Basic/Link/TextLink/TextLink.mjs';
import styled from 'styled-components';

const StyledCurrentWeather = styled(TextLink) `
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
`;

export { StyledCurrentWeather };
//# sourceMappingURL=CurrentWeather.styles.mjs.map
